// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__2zc9K","info":"PatientInfo_info__pSEi1"};